import DeclineRTPScreen from "./DeclineRTPScreen";

export default DeclineRTPScreen;
